module.exports = __webpack_public_path__ + "static/media/member-logo2.95be54af.jpg";